export const contactData = {
  label: "CONTACT",

  name: "Diya J Cyriac",

  subtitle: "Let’s build something meaningful together.",

  details: [
    {
      type: "email",
      value: "diyajcyriac@gmail.com",
      link: "mailto:diyajcyriac@gmail.com",
    },
    {
      type: "phone",
      value: "+91 7902355430",
    },
    {
      type: "location",
      value: "Kerala, India",
    },
  ],

  socials: [
    {
      type: "linkedin",
      link: "https://linkedin.com/in/diyajcyriac",
    },
    {
      type: "github",
      link: "https://github.com/diyajcyriac",
    },
  ],
};